import { useSelector } from 'react-redux';

import { RootState } from 'reducers/rootReducer';

export default function usePreferredNutrientIds() {
	return useSelector((state: RootState) => state.preferredNutrientIds);
}
